const t = {
  sm: "d-empty-state--size-sm",
  md: "d-empty-state--size-md",
  lg: "d-empty-state--size-lg"
}, e = {
  sm: "d-empty-state__content--sm",
  md: "d-empty-state__content--md",
  lg: "d-empty-state__content--lg"
}, d = {
  sm: "d-headline--md",
  md: "d-headline--xl",
  lg: "d-headline--xxl"
}, s = {
  sm: "d-body--sm",
  md: "d-body--sm",
  lg: "d-body--md"
}, m = {
  EMPTY_STATE_SIZE_MODIFIERS: t,
  EMPTY_STATE_CONTENT_SIZE_MODIFIERS: e,
  EMPTY_STATE_HEADLINE_SIZE_MODIFIERS: d,
  EMPTY_STATE_BODY_SIZE_MODIFIERS: s
};
export {
  s as EMPTY_STATE_BODY_SIZE_MODIFIERS,
  e as EMPTY_STATE_CONTENT_SIZE_MODIFIERS,
  d as EMPTY_STATE_HEADLINE_SIZE_MODIFIERS,
  t as EMPTY_STATE_SIZE_MODIFIERS,
  m as default
};
//# sourceMappingURL=empty-state-constants.js.map
